import React from 'react';

import style from './styles.module.scss';

export default function SearchIcon({
    className,
    dark
}) {
    return (
        <svg
            className={`${style.svg} ${dark ? style['svg--dark'] : ''} ${className ? className : ''}`}
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
        >
            <g fillRule="evenodd">
                <path d="M13.262 14.867l2.48 2.48c-.379.723-.418 1.442-.02 1.84l4.528 4.528c.57.57 1.813.258 2.766-.7.957-.956 1.27-2.195.699-2.765l-4.524-4.527c-.402-.399-1.12-.36-1.843.015l-2.48-2.476-1.606 1.605zM8.5 0C3.805 0 0 3.805 0 8.5S3.805 17 8.5 17 17 13.195 17 8.5 13.195 0 8.5 0zm0 15C4.91 15 2 12.09 2 8.5S4.91 2 8.5 2 15 4.91 15 8.5 12.09 15 8.5 15z" transform="translate(-1220 -40) translate(1220 40)"/>
            </g>
        </svg>
    );
}